module.exports = __webpack_public_path__ + "img/whats-new-7_cn.cd49a6b.jpg";